import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../common/breadcrumb";
import CartItemsListing from "./components/CartItemsListing";
import BillingDetails from "./components/BillingDetails";
import backend from "../../api";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";

const stripePromise = loadStripe(
  "pk_test_51Mm4i5BbiNWHJzfiKwdLrGwuhvo9zqQDTsxtKTePi6iliH6VWYL4TEVFB3N3EnnmnGyp3dlldupuIiVsuC8C8F4K00snGFrutv"
);

const Checkout = (props) => {
  const { items: cart = [] } = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.auth);
  const [calculations, setCalculation] = useState({});
  const history = useHistory();

  const getCartTotals = async () => {
    try {
      const response = await backend.get(`/cart/totals/${user?._id}`);
      setCalculation(response?.data);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    if (cart?.length > 0) {
      getCartTotals();
    } else {
      history.push("/merchants");
    }
  }, [cart]);

  return (
    <div>
      <Helmet>
        <title>eksplode! | Check Out Page</title>
      </Helmet>
      <Breadcrumb title={"Checkout"} />

      <section className="section-b-space">
        <div className="container padding-cls">
          <div className="checkout-page">
            <div className="checkout-form">
              <div className="row">
                <div className="col-6">
                  <div className="checkout">
                    <div className="checkout-details">
                      <CartItemsListing
                        calculations={calculations}
                        cart={cart}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="checkout">
                    <div className="checkout-details">
                      <Elements stripe={stripePromise}>
                        <BillingDetails calculations={calculations} />
                      </Elements>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Checkout;
